import React from "react";
import {
  Paper,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
} from "@mui/material";
import { RelationshipType } from "../types/customer";
import { elevation } from "../theme";

interface RelationshipSectionProps {
  relationshipType: string;
  onChange: (e: any) => void;
  error?: string;
}

export const RelationshipSection: React.FC<RelationshipSectionProps> = ({
  relationshipType,
  onChange,
  error,
}) => {
  return (
    <Paper sx={{ p: 3, height: "100%" }} elevation={elevation.paper}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">Relationship</Typography>
      </Box>

      <FormControl fullWidth error={!!error}>
        <InputLabel>Relationship Type</InputLabel>
        <Select
          value={relationshipType}
          label="Relationship Type"
          name="relationshipType"
          onChange={onChange}
        >
          {Object.values(RelationshipType).map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </Paper>
  );
};
